import { useEffect, useState } from 'react';
import type { AgoraParticipantLike } from '../../types';

export default function useTracks(participant: AgoraParticipantLike | null): any[] {
  const [tracks, setTracks] = useState<any[]>([]);

  useEffect(() => {
    if (!participant) {
      setTracks([]);
      return;
    }
    const pubs = participant.getPublications();
    setTracks(pubs.map(p => p.track).filter(Boolean));
  }, [participant]);

  return tracks;
}
